module.exports = __webpack_public_path__ + "static/media/seo.3fe47a5f.png";